// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__zfi9m"};